import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import themeReducer from '../slices/themeSlice';
import uiReducer from '../slices/uiSlice';
import productsReducer from '../slices/productsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    ui: uiReducer,
    products: productsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
